import React from "react";
import URLs from "constants/urls";
import ProviderBusiness from "../Reports/providerBusiness";
import { useMaterialUIController } from "context";
import dayjs from "dayjs";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
export default function ProviderBusinessByDsa() {
  const [controller] = useMaterialUIController();
  const { user } = controller;
  const url1 = `${URLs.provderWiseBusinessByDsaId}`;
  const url2 = `${URLs.providerWiseEntriesByDsaId}`;
  return (
    <DashboardLayout>
      <ProviderBusiness
        providerWiseBusinesByDateRange={url1}
        providerWiseBusinessEntriesURL={url2}
        isItByDsa={true}
      />
    </DashboardLayout>
  );
}
